export default "__VITE_ASSET__CldTRKE7__"